import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { selectCurrency } from "./actions";
import { getCurrency, setCurrency } from "./side_effects";
import { CurrenciesActionTypes } from "./types";

export function* handleCurrencyFetchLocalStorage(): SagaIterator {
  const currency = yield call(getCurrency);
  if (currency) {
    yield put(selectCurrency({ currency }));
  }
}

export function* handleCurrencySelect(action: ReturnType<typeof selectCurrency>): SagaIterator {
  yield call(setCurrency, action.payload.currency);
}

function* watchCurrenciesSagas(): SagaIterator {
  yield takeLatest(CurrenciesActionTypes.SELECT, handleCurrencySelect);
}

export default watchCurrenciesSagas;
